import Navbar from "shared/components/layout/Navbar";
import Footer from "shared/components/layout/Footer";
import { useTranslation } from "context/LanguageContext";

export default function OrderPageLayout({ children, header }) {
  const { language } = useTranslation();
  return (
    <div className="min-h-screen flex flex-col bg-gray-50" dir={language === "ar" ? "rtl" : "ltr"}>
      <Navbar />
      {header}
      <main className="flex-1 w-full max-w-4xl mx-auto px-4 py-10">{children}</main>
      <Footer />
    </div>
  );
}
